import { Button, DialogBody, Stack } from "@chakra-ui/react";
import { Form, UI } from "components";
import { API } from "config";
import { toaster } from "config";
import { useState } from "react";

export default function Attach({ data, ...props }){

    const [ file, setFile ] = useState()
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        if(!file) return
        setLoading(true)

        try{
            const form = new FormData()
            form.append('file', file)
            form.append('_method', 'put')
            await API.post(`/transactions/${data.id}/attach`, form, { headers: { "Content-Type": "multipart/form-data" } })
            toaster.create({ title: 'O comprovante foi anexado', type: 'success' })
            setFile(null)
            props?.onClose()
        }catch(err){
            toaster.create({ title: 'Não foi possível anexar o comprovante.', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <UI.Dialog title="Anexar comprovante" {...props}>
        <DialogBody>
            <Stack gap={4}>
                
                <UI.Alert size="sm">Só envie comprovantes caso você já tenha realizado o pagamento. Não serão aceitos comprovantes de agendamento.</UI.Alert>
                <Form.Upload.Button required disabled={loading} onChange={e => setFile(e.target?.files[0])} label="Comprovante de pagamento:" placeholder="Clique para anexar" />
                <Button colorPalette="orange" disabled={!file} loading={loading} loadingText="Anexando comprovante..." onClick={handleSubmit}><UI.Icon name="upload" /> Enviar comprovante</Button>

            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}